module.exports = __webpack_public_path__ + "img/img23.c8b8e6b1.png";